const JZhangFang = [{
  desc: '判断商户是否注册了金账房 或用户是否同步',
  options: {
    url: '/JZhangFang/queryJZhangFangUserStatus',
    method: 'get'
  }
}, {
  desc: '获取同步到金账房的人员',
  options: {
    url: '/JZhangFang/queryJZhangFangUsers',
    method: 'post'
  }
}, {
  desc: '金账房登录',
  options: {
    url: '/JZhangFang/loginJZhangFang',
    method: 'post'
  }
}, {
  desc: '获取账套列表',
  options: {
    url: '/JZhangFang/queryJZhangFangAcctList',
    method: 'get'
  }
}, {
  desc: '删除账套',
  options: {
    url: '/JZhangFang/deleteJZhangFangAcct',
    method: 'post'
  }
}, {
  desc: '禁用账号',
  options: {
    url: '/JZhangFang/disableJZhangFangUser',
    method: 'post'
  }
}, {
  desc: '获取角色权限列表',
  options: {
    url: '/JZhangFang/queryJZhangFangRoleList',
    method: 'get'
  }
}, {
  desc: '编辑同步人员的权限',
  options: {
    url: '/JZhangFang/updateJZhangFangUserRole',
    method: 'post'
  }
}, {
  desc: '获取所有财务权限但未同步金账房的人员',
  options: {
    url: '/JZhangFang/queryNotRelateUsers',
    method: 'get'
  }
}, {
  desc: '同步人员到金账房',
  options: {
    url: '/JZhangFang/addJZhangFangUser',
    method: 'post'
  }
}, {
  desc: '一键注册金账房',
  options: {
    url: '/JZhangFang/addJZhangFangPartner',
    method: 'post'
  }
}]
export default JZhangFang



// WEBPACK FOOTER //
// ./src/api/JZhangFang.js